import SourceProductGalleryContainer from 'SourceComponent/ProductGallery/ProductGallery.container';

export class ProductGalleryContainer extends SourceProductGalleryContainer {
    containerProps = () => {
        const { activeImage, isZoomEnabled } = this.state;
        const {
            product: {
                id,
                new_from_date,
                new_to_date,
                special_from_date,
                special_to_date,
                price_range,
                cart_rule_special_price : cartRuleSpecialPrice,
                attributes: {
                    sticker_info,
                    sticker_promo,
                    sticker_promo_account
                } = {},
                sku
            },
            stickersValues
        } = this.props;

        return {
            gallery: this.getGalleryPictures(),
            productName: this._getProductName(),
            activeImage,
            isZoomEnabled,
            productId: id,
            productStickers: {
                new_from_date,
                new_to_date,
                special_from_date,
                special_to_date,
                price: price_range,
                sticker_info,
                sticker_promo,
                sticker_promo_account,
                cartRuleSpecialPrice,
                stickersValues
            },
            sku
        };
    };
}

export default ProductGalleryContainer;
